import OrderInvoices from "@iewccouk/Components/OrderInvoices";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import React, { useContext } from "react";
import { connect } from "react-redux";

const OrderDetailsInvoices = () => {
    const order = useContext(OrderStateContext)?.value as any;

    return order ? (
      <OrderInvoices {...order} />
    ) : null;
};

const widgetModule: WidgetModule = {
    component: connect(null)(OrderDetailsInvoices),
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        displayName: "Order Invoices",
        group: "Order Details",
    },
};

export default widgetModule;
